/**
 * @class
 * @classdesc class used to manipulate DOM Meta
 */
class SeoSingleton {
    /**
     * @constructor
     */
    constructor() {
        this.selectors = {};
        this.selectors.description = document.querySelector("meta[name='description']");
        this.selectors.canonicalUrl = document.querySelector("link[rel='canonical']");
        this.selectors.alternateUrls = document.querySelectorAll("link[rel='alternate']");
    }

    /**
     * get meta title
     * @returns {string} document title
     */
    getTitle() {
        return document.title;
    }

    /**
     * set meta title
     * @param {string} title - new title
     */
    setTitle(title) {
        document.title = title;
    }

    /**
     * get meta description content
     * @returns {string} description
     */
    getDescription() {
        return this.selectors.description.getAttribute('content');
    }

    /**
     * set meta descriprion content
     * @param {string} description - new description
     */
    setDescription(description) {
        this.selectors.description.setAttribute('content', description);
    }

    /**
     * get meta canonical href
     * @returns {string} canonical url
     */
    getCanonicalHref() {
        return this.selectors.canonicalUrl.href;
    }

    /**
     * set url in meta caonical href
     * @param {string} url - new url
     */
    setCanonicalHref(url) {
        this.selectors.canonicalUrl.href = url;
    }

    /**
     * get alternate links DOMelts
     * @returns {NodeList} node list of alternate links
     */
    getAlternateLinksElts() {
        return this.selectors.alternateUrls;
    }
}

export const Seo = new SeoSingleton();
